module.exports = __webpack_public_path__ + "img/3.2f64e150.svg";